import React from 'react';
import {InputType} from '../../components/input/input.component';
import {FIXED_CHAR} from '../../components/fixedchar';
import AsciiTable from './ascii-table';


class Table extends React.Component {
    constructor(){
          super();
          this.state = {
            data: [
              [ "Ｄｉｓｅａｓｅ", "Ｄｅａｔｈｓ" ], 
              [ "Ｃｏｖｉｄ－１９", "３３１７９１２" ], 
              [ "Ｓｗｉｎｅｆｌｕ", "２８４０００" ]
            ], 
            dataType: null,
            isManualError: false,
            graph:null,
          }
       }
    strip = (str)=>{
        return str.replace(/^\s+|\s+$/g, '');
      }
    convertFixed = (str)=>{
        let tmp = "";
        console.log(str);
        for(let i=0; i<str.length; i++) {
          tmp+=FIXED_CHAR[str[i]];
        }
        console.log(tmp);
        return tmp;
      }
    handleInputChange = (event)=>{
        let data = event.target.value.split("\n");
        let eachRow = null;
        let parseEachRow; 
        let finalData = []
        for(let i=0; i<data.length; i++) {
            eachRow = data[i].split(",");
            parseEachRow = []
            for(let j=0; j<eachRow.length; j++) {
                if(j<eachRow.length-1 || this.strip(eachRow[j])!=="")
                    parseEachRow.push(this.convertFixed(this.strip(eachRow[j])));
            }
            if(parseEachRow.length > 0)
                finalData.push(parseEachRow);
        }
        this.setState({data: finalData});

    }
    createGraph = ()=>{
        var table = new AsciiTable()
        let data = this.state.data;
        table.setHeading(data[0])
        for(let i=1; i<data.length; i++){
            table.addRow(data[i])
        }
        console.log(this.state.data);
        this.setState({graph: table.toString()});
    }

    componentDidMount() {
      this.createGraph();
    }
    render() {
        let dataEntryType = null, graph=null;
        dataEntryType = <div className="col-4"> <InputType type="text" id="inputValues" placeholder={"Disease, Deaths, \nCovid-19,  3317912, \nSwineflu, 284000"} label="Values" name="values" handleInputChange={this.handleInputChange} /> </div>
        
        return (
          <div className="container graph">
            <div className="row">
            <h3 className="col-2">Table</h3>
            {dataEntryType}
            <div className="col-2"><button className="btn btn-primary " onClick={this.createGraph}>Get chart</button></div>
            {this.state.graph ? <pre className="col-3">{this.state.graph}</pre>:<p className="col-3">No data exists</p> } 

        </div>
        </div>);

        }
}


export default Table;